import { ConfigurationResult } from '@mews-distributor/data-access';
import { keyById } from '@mews/fp';
import { createReducer } from '@mews/framework';
import { FETCH_CONFIGURATIONS_SUCCEEDED } from '../../configuration/actionTypes';
import { Services } from './types';

const initialState = {};

export const servicesReducer = createReducer(initialState, {
    [FETCH_CONFIGURATIONS_SUCCEEDED]: (state: Services, { services }: ConfigurationResult) => ({
        ...state,
        ...keyById(services),
    }),
});
